<p>device-monitor-ether-vlan works!</p>
